import React, { Dispatch, SetStateAction } from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { MainInput, SimpleSelect } from 'src/commons';
import { Publication } from 'src/app/models/business/Publication';
import { grey } from 'src/theme/colors';
import { PublicationFilters, ZoneFilterOption } from './types';
import { useFiltersLogic } from './hooks/useFiltersLogic';
import { MetricsCards } from './components/MetricsCards';
import { ZoneMultiSelect } from './components/ZoneMultiSelect';

const useStyles = makeStyles({
  filtersTitle: {
    color: grey.medium,
    fontWeight: 'normal',
    marginBottom: 12,
  },
  filtersRow: {
    display: 'grid',
    gridTemplateColumns: '7fr 1.5fr 1.5fr',
    gap: 12,
    width: '100%',
    alignItems: 'end',
  },
  fieldWrapper: {
    minWidth: 0,
    width: '100%',
    '& article': {
      width: '100%',
    },
  },
  root: {
    width: '100%',
  },
});

export type PublicationsHeaderProps = {
  filter: PublicationFilters;
  onChangeFilter: Dispatch<SetStateAction<PublicationFilters>>;
  publications: Publication[];
  totalCount?: number;
  zoneOptions: ZoneFilterOption[];
  loadingZones?: boolean;
};

const STATUS_OPTIONS = [
  { id: '', name: 'Todos los estados' },
  { id: 'activa', name: 'Activa' },
  { id: 'inactiva', name: 'Inactiva' },
];

export const PublicationsHeader = ({
  filter,
  onChangeFilter,
  publications,
  totalCount,
  zoneOptions,
  loadingZones = false,
}: PublicationsHeaderProps) => {
  const classes = useStyles();
  const { search, status, zoneIds, onSearchChange, onStatusChange, onZoneChange } = useFiltersLogic({
    filter,
    onChangeFilter,
  });

  const selectableZoneOptions = zoneOptions.filter((option) => option.id);

  return (
    <Grid container spacing={2} direction="column" className={classes.root}>
      <Grid item xs={12}>
        <MetricsCards publications={publications} totalCount={totalCount} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4" className={classes.filtersTitle}>
          Filtros
        </Typography>
        <div className={classes.filtersRow}>
          <div className={classes.fieldWrapper}>
            <MainInput
              type="search"
              handleChange={onSearchChange}
              placeholder="Buscar por Pub. ID, SKU..."
              name="search"
              value={search}
              fullWidth
            />
          </div>
          <div className={classes.fieldWrapper}>
            <SimpleSelect
              value={status}
              placeholder="Estado"
              onChange={onStatusChange}
              content={STATUS_OPTIONS}
              valueKey="id"
              labelKey="name"
              idKey="id"
            />
          </div>
          <div className={classes.fieldWrapper}>
            <ZoneMultiSelect
              selected={zoneIds}
              placeholder="Zona"
              onChange={onZoneChange}
              options={selectableZoneOptions}
              loading={loadingZones}
            />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
